/**
 * @license lucide-react v0.484.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';
var __iconNode = [["path", {
  d: "M8 18L12 22L16 18",
  key: "cskvfv"
}], ["path", {
  d: "M12 2V22",
  key: "r89rzk"
}]];
var MoveDown = createLucideIcon("move-down", __iconNode);
export { __iconNode, MoveDown as default };